<template>
    <div class="container">
        <nav>
            <ol class="breadcrumb p-1 my-1">
                <span class="ml-auto mr-2 text-muted"> {{getTechLevel.act}}&nbsp;/&nbsp;{{getTechLevel.cnt}}人</span>
            </ol>
        </nav>
        <div class="accordion mb-2" id="accordion-tech-level" role="tablist" aria-multiselectable="true" v-if="getTechLevel.length != 0">
            <div v-for="(item,index) in getTechLevel.levels" :key="index" class="card border border-bottom mb-1">
                <a class="card-header text-dark text-decoration-none" role="tab" id="headingOne" data-toggle="collapse" :href="'#collapseOne' + index" aria-expanded="true" aria-controls="collapseOne">
                    <div class="row">
                        <div class="col-3 pr-0">
                            <i class="fas fa-align-justify icon-size"></i>
                            {{item.level}}
                        </div>
                        <div class="col-3 px-0">
                            <i class="fas fa-user-friends icon-size"></i>
                            {{item.all_cnt}}
                        </div>
                        <div class="col px-0">
                            <i class="fas fa-user-check text-success icon-size"></i>
                            {{item.act_cnt}}
                        </div>
                    </div>
                </a>
                <div :id="'collapseOne' + index" class="collapse" role="tabpanel" aria-labelledby="headingOne" data-parent="#accordion-tech-level">
                    <ul class="list-group list-group-flush border-top">
                        <li class="list-group-item" v-for="child in item.list" :key="child.id" >
                            <tech-row :item="child"></tech-row>
                        </li>
                    </ul>
                    <!-- /.card-body -->
                </div>
            </div>
        </div><!-- /#accordion -->

        <!-- 0件メッセージ -->
        <not-found-msg v-else></not-found-msg>

    </div>
</template>

<script>
    import NotFoundMsg from 'pages/commons/notFoundMsg/NotFoundMsg'
    import TechRow from './Row'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            NotFoundMsg,
            TechRow
        },
        computed: {
            ...mapGetters(['getTechLevel'])
        },
        methods: {
            toTechChild (code,name,level) {
                this.$parent.toTechChild(code,name,level)
            },
           // toPerson (userId) {
           //     this.$parent.toPerson(userId)
           // }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .opacity0
        opacity: 0
    .wrapper-name
        display:flex
        white-space: nowrap
        .name
            ellipsis()
</style>
